interface EkoLogoProps {
  height: number;
}

export function EkoLogo({ height = 28 }: EkoLogoProps) {
  const width = (height * 65) / 28;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 65 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.6113 18.9251H54.4873L49.6284 12.9414L53.7188 9.08715H51.7768L47.346 13.3525V4.43652H45.793V18.9251H47.346V15.1713L48.5774 13.9689L52.6113 18.9251Z"
        fill="currentColor"
      />
      <path
        d="M59.3854 8.82739C56.4713 8.82739 54.1006 11.1506 54.1006 14.0054C54.1006 16.8602 56.4713 19.1833 59.3854 19.1833C62.2998 19.1833 64.6702 16.8602 64.6702 14.0054C64.6702 11.1506 62.2998 8.82739 59.3854 8.82739ZM59.3854 17.818C57.2327 17.818 55.6094 16.1793 55.6094 14.0054C55.6094 11.8314 57.2327 10.1927 59.3854 10.1927C61.5384 10.1927 63.1612 11.8314 63.1612 14.0054C63.1612 16.1793 61.5384 17.818 59.3854 17.818Z"
        fill="currentColor"
      />
      <path
        d="M42.0705 16.5108C41.399 17.3272 40.3516 17.818 39.2173 17.818C37.2601 17.818 35.7223 16.2668 35.5462 14.6044H44.0777C44.2225 12.9614 43.6966 11.3163 42.6999 10.2687C41.8148 9.33961 40.5109 8.82739 39.1434 8.82739C36.2786 8.82739 34.0215 11.1506 34.0215 14.0054C34.0215 16.8602 36.3525 19.1833 39.2173 19.1833C40.9057 19.1833 42.923 18.2671 43.7915 16.5101H42.0705V16.5108ZM35.5673 13.3531C35.8172 11.6097 37.284 10.1927 39.1506 10.1927C41.11 10.1927 42.4624 11.68 42.521 13.3531H35.568H35.5673Z"
        fill="currentColor"
      />
      <path
        opacity={0.35}
        d="M27.0579 14.6464H28.5827C28.5928 14.4319 28.5986 14.2167 28.5986 14C28.5986 6.28004 22.2576 0 14.4643 0C6.67107 0 0.330078 6.28004 0.330078 14C0.330078 21.72 6.67029 28 14.4643 28C21.3927 28 27.1723 23.0366 28.3704 16.5104H26.8181C25.6418 22.1985 20.5496 26.4904 14.4643 26.4904C7.73006 26.4904 2.21121 21.2342 1.87077 14.6464H4.85364C4.83916 14.4326 4.83119 14.2174 4.83119 14C4.83119 13.7826 4.83916 13.5674 4.85364 13.3536H1.87077C2.21121 6.76504 7.73006 1.50884 14.4643 1.50884C21.1986 1.50884 26.7175 6.76504 27.0579 13.3528H24.1185C24.1329 13.5667 24.1409 13.7819 24.1409 13.9993C24.1409 14.2167 24.1329 14.4319 24.1185 14.6457H27.0579V14.6464Z"
        fill="currentColor"
      />
      <path
        d="M17.1492 16.5096C16.4756 17.217 15.5216 17.6597 14.4641 17.6597C12.6488 17.6597 11.1364 16.3568 10.8271 14.6456H19.641C19.6678 14.4332 19.683 14.218 19.683 13.9992C19.683 11.1487 17.3419 8.82983 14.4641 8.82983C11.5862 8.82983 9.24512 11.1487 9.24512 13.9992C9.24512 16.8497 11.5862 19.1686 14.4641 19.1686C16.4227 19.1686 18.1314 18.0938 19.0238 16.5096H17.1485H17.1492ZM14.4641 10.3386C16.2793 10.3386 17.7917 11.6416 18.101 13.3527H10.8278C11.1371 11.6416 12.6496 10.3386 14.4648 10.3386H14.4641Z"
        fill="currentColor"
      />
      <path
        opacity={0.6}
        d="M22.5883 14.6462H24.1181C24.1326 14.4323 24.1405 14.2171 24.1405 13.9997C24.1405 8.7263 19.8089 4.43652 14.4857 4.43652C9.16239 4.43652 4.83008 8.7263 4.83008 13.9997C4.83008 19.2731 9.16168 23.5628 14.485 23.5628C18.9317 23.5628 22.6853 20.5696 23.8016 16.5101H22.2094C21.1425 19.7258 18.0835 22.054 14.485 22.054C10.2214 22.054 6.71555 18.7859 6.38164 14.6462H9.28631C9.2595 14.4338 9.24425 14.2185 9.24425 13.9997C9.24425 13.7808 9.2595 13.5649 9.28631 13.3533H6.38164C6.71555 9.21344 10.2207 5.94537 14.485 5.94537C18.7492 5.94537 22.2543 9.21344 22.5883 13.3533H19.6409C19.6677 13.5656 19.6829 13.7808 19.6829 13.9997C19.6829 14.2185 19.6677 14.4345 19.6409 14.6462H22.5883Z"
        fill="currentColor"
      />
    </svg>
  );
}
